import { styled, theme } from '../../lib'

export const StyledIcon = styled('div', {
  display: 'flex',
  transform: 'rotate(0deg)',

  variants: {
    rotate: {
      '90': {
        transform: `rotate(90deg)`
      },
      '180': {
        transform: `rotate(180deg)`
      },
      '270': {
        transform: `rotate(270deg)`
      }
    },
    size: {
      small: {
        height: theme.sizes.ui_16,
        width: theme.sizes.ui_16
      },
      medium: {
        height: theme.sizes.ui_20,
        width: theme.sizes.ui_20
      },
      large: {
        height: theme.sizes.ui_24,
        width: theme.sizes.ui_24
      }
    }
  }
})
